module.exports = __webpack_public_path__ + "img/007-barque.e4b0324e.svg";